export const toHijriDate = (givenDate) => {
	if (givenDate) {
		const convertedDate = new Date(givenDate);
		const numericValues = new Intl.DateTimeFormat("fa-IR", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			numberingSystem: "latn",
			hour12: false,
		}).formatToParts(convertedDate);

		const stringValues = new Intl.DateTimeFormat("fa-IR", {
			month: "long",
			weekday: "long",
		}).formatToParts(convertedDate);

		const convertPartedDateToKeyValue = (givenArray) => {
			return givenArray.reduce((prev, next) => {
				return {
					...prev,
					[next.type]: next.value,
				};
			}, {});
		};

		const partedNumericValues = convertPartedDateToKeyValue(numericValues);
		const partedStringValues = convertPartedDateToKeyValue(stringValues);

		return {
			year: partedNumericValues.year,
			monthNumber: partedNumericValues.month,
			monthName: partedStringValues.month,
			dayNumber: partedNumericValues.day,
			weekdayNumber: convertedDate.getDay(),
			weekdayName: partedStringValues.weekday,
			hour: partedNumericValues.hour,
			minute: partedNumericValues.minute,
			second: partedNumericValues.second,
		};
	}
	return "";
};
